import React, { PropsWithChildren, ReactNode } from "react";
import Header from "./Header";
import type { PageProps } from "gatsby";
import Footer from "./Footer";

export default function Layout({
  children,
  header,
  location,
  startBackgroundClassName,
  endBackgroundClassName,
}: PropsWithChildren<
  Pick<PageProps, "location"> & {
    header?: ReactNode;
    startBackgroundClassName?: string;
    endBackgroundClassName?: string;
  }
>) {
  return (
    <>
      <Header
        location={location}
        children={header}
        backgroundClassName={startBackgroundClassName}
      />
      {children}
      <Footer backgroundClassName={endBackgroundClassName} />
    </>
  );
}
